import { Button, Flex, Modal } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { usePublishersStore } from '@/shared/stores/publishers.store';

import { useDeletePublisherMutation } from '../model/delete-publisher-modal.cases';

export function DeletePublisherModal() {
  const deletablePublisher = usePublishersStore(
    (state) => state.deletablePublisher,
  );
  const setDeletablePublisher = usePublishersStore(
    (state) => state.setDeletablePublisher,
  );
  const deletePublisherMutation = useDeletePublisherMutation();

  return (
    <Modal
      opened={!!deletablePublisher}
      onClose={() => setDeletablePublisher(null)}
      title="Удаление издательства"
    >
      {deletablePublisher && (
        <>
          <p>
            Вы действительно хотите удалить издательство{' '}
            <b>{deletablePublisher.title}</b>?
          </p>
          <Flex justify="space-between" gap={16} mt={20}>
            <Button
              variant="light"
              fullWidth
              onClick={() => setDeletablePublisher(null)}
            >
              Отменить
            </Button>
            <Button
              fullWidth
              color="red"
              loading={deletePublisherMutation.isPending}
              onClick={() => {
                void deletePublisherMutation
                  .mutateAsync(deletablePublisher.id)
                  .then((result) => {
                    setDeletablePublisher(null);

                    notifications.show({
                      message: 'Издательство удалено',
                      color: 'green',
                    });
                    return result;
                  });
              }}
            >
              Удалить
            </Button>
          </Flex>
        </>
      )}
    </Modal>
  );
}
